export default {
  currentOrg: {},
  isFetchingCurrentOrg: false,
  currentOrgError: null,

  orgs: [],
  isFetchingAllOrgs: false,
  orgsError: null,
};
